// Konfiguracja API dla stałego klienta KMX – musi być identyczny z server/src/config/apiKeyManager.js (getAuthKey / DEFAULT_KEY)
export const API_KEY = 'YXBwbGljYXRpb240Oms0YUIzdnlSY01kR2lUTlZwcmJ3WEV0ZzVyT3JzS0RQcnpyUCs0b1JCaW5ZQmlBWWZIOWF5SXk4ZEQ2SkpWSlM=';
const SHOP_URL = 'https://kmxfashion.pl';
// Używamy publicznego proxy CORS
const CORS_PROXY = 'https://api.allorigins.win/raw?url=';
// API: na produkcji (kmx.sortujto.pl) używamy tej samej domeny (/api/...) żeby uniknąć błędu certyfikatu
function getApiBase() {
  if (typeof window !== 'undefined' && window.location.origin === 'https://kmx.sortujto.pl') {
    return ''; // relative – ta sama domena, proxy w nginx
  }
  return 'https://api.kmx.sortujto.pl';
}
export const KMX_API = 'https://api.kmx.sortujto.pl'; // fallback (np. localhost)
export function getKMXApiBase() {
  const base = getApiBase();
  return base === '' ? '' : base;
}

/**
 * Aktualizuje klucz API IdoSell na serwerze (bez edycji kodu).
 * Wywoływane z zakładki Ustawienia w aplikacji.
 * @param {string} newKey - nowy klucz API (Base64)
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export const updateIdoSellApiKey = async (newKey) => {
  if (!newKey || typeof newKey !== 'string' || !newKey.trim()) {
    throw new Error('Klucz API nie może być pusty');
  }
  const response = await fetch(`${getKMXApiBase()}/api/settings/api-key`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-KEY': API_KEY,
      'Accept': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ apiKey: newKey.trim() })
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Błąd ${response.status}: ${response.statusText}`);
  }
  return data;
};

// Funkcja do normalizacji ścieżek węzłów (taka sama jak w xmlParser.js)
const normalizeNodePath = (path) => {
  if (!path) return path;
  
  // Zastępujemy podwójne ukośniki pojedynczymi
  let normalized = path.replace(/\\\\/g, '\\');
  
  // Usuwamy nadmiarowe spacje na początku i końcu
  normalized = normalized.trim();
  
  // W niektórych implementacjach XML podwójne ukośniki mogą być zamieniane na pojedyncze slash (/)
  if (normalized.includes('/')) {
    normalized = normalized.replace(/\//g, '\\');
  }
  
  // Upewniamy się, że używamy prawidłowego formatu ukośników
  if (normalized.includes('\\\\')) {
    normalized = normalized.replace(/\\\\/g, '\\');
  }
  
  return normalized;
};

// Funkcja pomocnicza do przygotowania URL API
// eslint-disable-next-line no-unused-vars
const prepareApiUrl = (endpoint) => {
  // Budujemy URL z odpowiednim endpointem API
  const apiUrl = new URL(`${SHOP_URL}/api/admin/v5${endpoint}`);
  
  // Zwracamy URL bez proxy dla żądań POST - proxy będzie użyte w konfiguracji serwera
  return apiUrl.toString();
};

export const fetchProductsFromShop = async () => {
  try {
    // Budujemy URL z parametrami
    const apiUrl = new URL(`${SHOP_URL}/api/admin/v5/products/list`);
    apiUrl.searchParams.append('page', '1');
    apiUrl.searchParams.append('limit', '1000');
    apiUrl.searchParams.append('response_format', 'xml');
    
    // Dodajemy proxy do URL
    const proxyUrl = `${CORS_PROXY}${encodeURIComponent(apiUrl.toString())}`;
    
    const response = await fetch(proxyUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Basic ${API_KEY}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const data = await response.text();
    console.log('Received data:', data.substring(0, 200));
    return data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// Funkcja do aktualizacji priorytetów produktów w sklepie
export const updateProductPriorities = async (productsWithPriorities) => {
  try {
    // Używamy dedykowanego API dla KMX
    const apiUrl = `${getKMXApiBase()}/api/products/products`;
    console.log('API URL:', apiUrl);
    console.log('Docelowy adres API: https://kmxfashion.pl/api/admin/v5/products/products');

    // Wyświetlamy informacje o produktach dla debugowania
    console.log('Produkty przed przetworzeniem:', JSON.stringify(productsWithPriorities.map(p => ({
      id: p.id,
      menuItems: p.menuItems ? p.menuItems.map(i => ({
        textId: i.textId,
        level: i.level
      })) : []
    })), null, 2));

    // Groupa produkty po ID (zamiast tworzyć osobne wpisy dla każdego rozmiaru)
    const groupedProducts = [];
    const processedIds = new Set();

    productsWithPriorities.forEach(product => {
      if (processedIds.has(product.id)) return;
      processedIds.add(product.id);
      groupedProducts.push(product);
    });

    console.log(`Przetwarzam ${groupedProducts.length} unikalnych produktów (po grupowaniu)`);
    
    // NOWOŚĆ: Podziel produkty na partie po 100 sztuk
    const batchSize = 100;
    const batches = [];
    
    // Dzielimy produkty na partie
    for (let i = 0; i < groupedProducts.length; i += batchSize) {
      batches.push(groupedProducts.slice(i, i + batchSize));
    }
    
    console.log(`Podzielono produkty na ${batches.length} partii po maksymalnie ${batchSize} produktów`);
    
    // Tablica na wyniki
    const results = [];
    
    // Przetwarzamy partie sekwencyjnie
    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const batch = batches[batchIndex];
      console.log(`Przetwarzanie partii ${batchIndex + 1}/${batches.length} z ${batch.length} produktami`);
      
      // Przygotowanie danych zgodnie z formatem wymaganym przez API IdoSell
      const payload = {
        params: {
          products: batch.map(product => {
            // Domyślna wartość priorytetu
            const productPriority = 920;
            
            // Tworzymy tablicę na wszystkie węzły menu produktu z ich ID i priorytetami
            const productMenuNodes = [];
            
            if (product.menuItems && product.menuItems.length > 0) {
              // Pobierz oryginalną strukturę menu z XML dla tego produktu
              const originalMenuItems = product.originalData?.['iaiext:priority_menu']?.site?.[0]?.menu?.[0]?.item || [];

              // Dla każdego elementu menu w produkcie
              product.menuItems.forEach(menuItem => {
                let menuNodeId = null;
                let menuNodePriority = parseInt(menuItem.level) || productPriority;
                
                // Normalizujemy textId z menuItem
                const normalizedMenuItemTextId = normalizeNodePath(menuItem.textId);
                
                // PRIORYTET 1: Sprawdź czy menuItem ma już zapisane nodeId (z parsera XML)
                // To jest najnowsze ID, które może być aktualne nawet po zmianach w menu
                if (menuItem.nodeId && parseInt(menuItem.nodeId) > 0) {
                  menuNodeId = parseInt(menuItem.nodeId);
                  console.log(`Używam nodeId z menuItem "${menuItem.textId}" dla produktu ${product.id}: ID ${menuNodeId} (priorytet: ${menuNodePriority})`);
                } else {
                  // PRIORYTET 2: Jeśli nie ma nodeId w menuItem, szukaj w originalMenuItems
                  // Używamy normalizacji, aby obsłużyć różne formaty ścieżek
                  const originalMenuItem = originalMenuItems.find(item => {
                    const originalTextId = item.textId || item.textid || '';
                    const normalizedOriginalTextId = normalizeNodePath(originalTextId);
                    
                    // Porównujemy znormalizowane wersje
                    return normalizedOriginalTextId === normalizedMenuItemTextId;
                  });
                  
                  if (originalMenuItem && originalMenuItem.id) {
                    menuNodeId = parseInt(originalMenuItem.id);
                    console.log(`Znaleziono węzeł menu "${menuItem.textId}" (znormalizowane: "${normalizedMenuItemTextId}") dla produktu ${product.id} z ID ${menuNodeId} z originalMenuItems (priorytet: ${menuNodePriority})`);
                  } else {
                    // Dodatkowe debugowanie - sprawdź wszystkie dostępne węzły w originalMenuItems
                    const availableNodes = originalMenuItems.map(item => {
                      const originalTextId = item.textId || item.textid || '';
                      return {
                        original: originalTextId,
                        normalized: normalizeNodePath(originalTextId),
                        id: item.id
                      };
                    });
                    console.warn(`Nie znaleziono węzeł menu "${menuItem.textId}" (znormalizowane: "${normalizedMenuItemTextId}") dla produktu ${product.id}`);
                    console.warn(`Dostępne węzły w originalMenuItems:`, availableNodes);
                    console.warn(`menuItem.nodeId:`, menuItem.nodeId);
                  }
                }
                
                // Dodaj węzeł do listy tylko jeśli znaleziono ID
                if (menuNodeId && menuNodeId > 0) {
                  productMenuNodes.push({
                    productMenuNodeId: menuNodeId,
                    productPriority: menuNodePriority,
                    shopId: 1,
                    productMenuTreeId: 1
                  });
                } else {
                  console.error(`BŁĄD: Nie można znaleźć ID węzła menu "${menuItem.textId}" dla produktu ${product.id}. Węzeł zostanie pominięty.`);
                }
              });
            }
            
            // Zwracamy obiekt produktu z węzłami menu
            return {
              productId: product.id,
              productPriorityInMenuNodes: productMenuNodes
            };
          })
        }
      };
      
      console.log('Wysyłanie żądania PUT do API:', JSON.stringify(payload, null, 2));
      
      try {
        // Wysyłamy żądanie PUT do API
        const response = await fetch(apiUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': API_KEY,
            'Accept': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify(payload)
        });
        
        console.log('Status odpowiedzi:', response.status);
        console.log('Nagłówki odpowiedzi:', Object.fromEntries(response.headers.entries()));
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Błąd odpowiedzi:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }
        
        const data = await response.json();
        console.log('Odpowiedź z API:', data);
        results.push(data);
      } catch (fetchError) {
        console.error('Błąd podczas wysyłania żądania:', fetchError);
        console.error('Szczegóły żądania:', {
          url: apiUrl,
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': API_KEY,
            'Accept': 'application/json'
          }
        });
        throw fetchError;
      }
    }
    
    return results;
  } catch (error) {
    console.error('Szczegółowy błąd podczas aktualizacji priorytetów:', error);
    
    // Lepsze formatowanie komunikatu błędu
    let errorMessage = 'Nieznany błąd';
    let errorDetails = '';
    
    if (error instanceof Error) {
      errorMessage = error.message;
      errorDetails = error.stack || '';
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else if (error && typeof error === 'object') {
      // Sprawdzamy różne możliwe właściwości błędu
      errorMessage = error.message || error.error || error.statusText || 'Błąd obiektu bez opisu';
      errorDetails = JSON.stringify(error);
    }
    
    console.error('Sformatowany komunikat błędu:', errorMessage);
    console.error('Szczegóły błędu:', errorDetails);
    
    throw new Error(`Błąd podczas aktualizacji priorytetów produktów: ${errorMessage}`);
  }
}; 